/**
 * Module dependencies.
 */

import { getNames, registerLocale } from 'i18n-iso-countries';
import { useRouter } from 'next/router';
import orderBy from 'lodash/orderBy';

/**
 * Locales.
 */

const locales = process.env.NEXT_PUBLIC_LOCALIZATION_LOCALES.split(',');

/**
 * Register i18n locales.
 */

locales.map(locale => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  registerLocale(require(`i18n-iso-countries/langs/${locale}.json`));
});

/**
 * Export `Country` type.
 */

export type Country = {
  alpha2: string;
  name: string;
};

/**
 * Export `useCountriesList`.
 */

export function useCountriesList(): Country[] {
  const { locale } = useRouter();
  const list = Object.entries(getNames(locale, { select: 'official' })).map(
    ([alpha2, name]) => ({ alpha2, name })
  );

  return orderBy(list, 'name');
}
